import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Svg } from './icon.svg'

const ImportIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} component={Svg} sx={{ fill: 'none', ...props.sx }}/>
  )
}

export default ImportIcon
